module.exports = __webpack_public_path__ + "static/media/spoonsnladles.95ead071.jpg";